"use client";

import { motion, useAnimation } from "framer-motion";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
const HEAD_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0
  },
  animate: {
    translateX: [0, 3, 0],
    translateY: [0, -3, 0],
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  }
};
const SHAFT_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0,
    scale: 1
  },
  animate: {
    translateX: [0, 3, 0],
    translateY: [0, -3, 0],
    scale: [1, 0.85, 1],
    originX: 1,
    originY: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  }
};
const ArrowDownLeftIcon = forwardRef(({
  onMouseEnter,
  onMouseLeave,
  className,
  size = 28,
  ...props
}, ref) => {
  const controls = useAnimation();
  const isControlledRef = useRef(false);
  useImperativeHandle(ref, () => {
    isControlledRef.current = true;
    return {
      startAnimation: () => controls.start("animate"),
      stopAnimation: () => controls.start("normal")
    };
  });
  const handleMouseEnter = useCallback(e => {
    if (!isControlledRef.current) controls.start("animate");
    onMouseEnter?.(e);
  }, [controls, onMouseEnter]);
  const handleMouseLeave = useCallback(e => {
    if (!isControlledRef.current) controls.start("normal");
    onMouseLeave?.(e);
  }, [controls, onMouseLeave]);
  return <div className="contents" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...props}>
      <svg className={className} fill="none" height={size} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
        <motion.path animate={controls} d="M17 17H7V7" variants={HEAD_VARIANTS} />
        <motion.path animate={controls} d="M7 17 L12 12" variants={SHAFT_VARIANTS} />
        <path d="M17 7 L12 12" />
      </svg>
    </div>;
});
ArrowDownLeftIcon.displayName = "ArrowDownLeftIcon";
export { ArrowDownLeftIcon };
